import React, { memo } from "react";
import { useSimilarMastersQuery } from "@/hooks/queries/useSimilarMastersQuery";
import { Selectors } from "@/store/masterProfile/selectors";
import { useSelector } from "react-redux";
import QueryRequest from "@/components/QueryRequest";
import { Link } from "react-router-dom";
import { LinkGenerator } from "@/utils/LinkGenerator";
import SectHeader from "_c/modules/profile/common/SectHeader";
import isempty from "lodash/isEmpty";
import { generateAvatar } from "@/utils";
import type { TFunction } from "i18next";

const avatarWidth = 170;
const avatarHeight = 215;

type tProps = {
  t: TFunction;
};
const SimilarMasters = ({ t }: tProps) => {
  const masterId: string = useSelector(Selectors.getMasterId);
  const query = useSimilarMastersQuery(masterId);
  const masters = query.data?.masters;

  return (
    <QueryRequest query={query}>
      {!isempty(masters) && (
        <>
          <SectHeader>{t("master_profile:similar_masters.title")}</SectHeader>
          <ul
            css={`
              display: flex;
              width: 95%;
              margin: 0 auto;
              -webkit-overflow-scrolling: touch;
              overflow-x: auto;
              justify-content: flex-start;
              flex-wrap: nowrap;
              position: relative;
              scroll-snap-type: x mandatory;
              ::before,
              ::after {
                content: ""; /* Insert pseudo-element */
                margin: auto; /* Make it push flex items to the center */
              }
            `}
          >
            {masters!.map(({ _id, user }) => (
              <li
                key={_id}
                css={`
                  width: ${avatarWidth}px;
                  min-width: ${avatarWidth}px;
                  margin: 5px;
                  padding-bottom: 5px;
                `}
              >
                <Link to={LinkGenerator.masterProfile(_id)}>
                  <img
                    loading="lazy"
                    css={`
                      display: block;
                      margin-bottom: 10px;
                      width: 100%;
                      height: ${avatarHeight}px;
                      border-radius: 7px;
                    `}
                    src={generateAvatar({
                      url: user.avatar,
                      sex: user.sex,
                      rect: true,
                      width: avatarWidth * 2,
                      height: avatarHeight * 2,
                    } as any)}
                  />
                  <span
                    css={`
                      color: var(--font-color-accent);
                    `}
                  >
                    {[user.first_name, user.last_name]
                      .filter(Boolean)
                      .join(" ")}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
    </QueryRequest>
  );
};

export default memo(SimilarMasters);
